import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'extractAndWrapLinks',
    standalone: true,
})
export class ExtractAndWrapLinksPipe implements PipeTransform {

  /**
   * Transforms the value `abd www.a.com` to `abd <a href="...">...</a>`
   * If found URL does not start with a net protocol, prepend it with 'https://' in href so that
   * the browser knows it's dealing with an absolute URL
   * @param value
   */
  transform(value: string): string {
    const protocolRegExp = /((http|ftp|https):\/\/)/gm;
    return value.replace(/((http|ftp|https):\/\/)?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])?/gm,
        `<a href=${protocolRegExp.test(value) ? '\$&' : 'https://$&'} target="_blank">$&</a>`);
  }
}